import { router } from '../../../app';
import { store } from '../../'

const state = () => ({
    buyers: [],
    extras: [],
    availableExtras: [],
    selectedBox: null,
    productNameSearch: null,
    productIdSearch: null,
    productSkuSearch: null,
    productImageSrc: '/images/no-image.png',
    validationGroups: null,
    currentPage: null,
    itemFetchError: '',
    itemReportList:{
        invitem: {
            model:"Invitem",
            columns: {
                "id":{
                    "displayName":"ID","dataType":"int","sortable":0,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"id"
                },
                "name":{
                    "displayName":"Item Name","dataType":"string","sortable":1,"sort":"asc","sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"name"
                },
                "sku":{
                    "displayName":"SKU","dataType":"string","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"sku"
                },
                /*"cost":{
                    "displayName":"Cost","dataType":"currency","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":{"min":"0","max":"17333100","count":234144,"missing":"0","sum":"1987319101.07","sumOfSquares":"1.5016735702449E+15","mean":"8487.5935367552","stdDev":"79633.218657191"},"rangeGap":1000,"name":"cost"
                },*/
                "retail":{
                    "displayName":"Retail","dataType":"currency","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":{"min":"0","max":"199000","count":233453,"missing":"691","sum":"318095005.69","sumOfSquares":"1133461963823.8","mean":"1362.5655086463","stdDev":"1731.6559080572"},"rangeGap":1000,"name":"retail"
                },
                /*"color":{
                    "displayName":"Color","dataType":"tag","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"color"
                },
                "origin":{
                    "displayName":"Origin","dataType":"tag","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"origin"
                },*/
                "brand":{
                    "displayName":"Brand","dataType":"tag","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"brand"
                },
                /*"style":{
                    "displayName":"Style","dataType":"tag","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"style"
                },
                "material":{
                    "displayName":"Material","dataType":"tag","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"material"
                },"size":{
                    "displayName":"Size","dataType":"tag","sortable":1,"sort":null,"sortPriority":0,"facets":[],"metrics":[],"rangeGap":null,"name":"size"
                }*/
            },
            availableColumns: [],
            textFilter: '',
            page: 0,
            data: [],
            results: null,
            selectedFacets: [],
            sorts: {"name":{"direction":"asc","order":0}},
            updated: null,
            name: '',
            selectionMode: 'multiple',
            title: 'All Items',
            reportButtons: [
                {action: 'ship-box', label: 'Ship Box Now!', class: 'btn-success' }
            ],
            rowActions: [
                {action: 'manage-box', label: 'Manage Box'},
                {action: 'print-label', label: 'Print Label'},
                {action: 'print-loa', label: 'Print LOA'},
                {action: 'edit-item', label: 'Edit Item'},
                {action: 'item-card', label: 'Go to Item Card'},
                {action: 'open-receipt', label: 'Open Receipt'},
                {action: 'delete', label: 'Delete'}
            ]
        }
    }
});
const getters = {
    buyTeam: state => state.buyTeam,
    buyers: state => state.buyers,
    availableExtras: state => state.availableExtras,
    extras: state => state.extras,
    productNameSearch: state => state.productNameSearch,
    productIdSearch: state => state.productIdSearch,
    productSkuSearch: state => state.productSkuSearch,
    productImageSrc: state => state.productImageSrc,
    validationGroups: state => state.validationGroups,
    currentPage: state => state.currentPage,
    itemFetchError: state => state.itemFetchError,
    selectedBox: state => state.selectedBox,
    itemReportList: state => state.itemReportList.invitem
};

const mutations = {
    updateState(state, payload){ 
        //console.log('mutation called: '+ payload.field + ' = ' + payload.value);
        state[payload.field] = payload.value 
    }
};

const actions = {
    set({commit}, payload){ 
        //console.log('action called: '+ payload.field + ' = ' + payload.value);
        commit('updateState', {field: payload.field, value: payload.value}) 
    },
    parseFetched({commit, dispatch, state}, payload){
        return new Promise((resolve, reject) => {
            //console.log('ParseFetched: response: ' + payload.response );
            console.log('ParseFetched: sku: ' + payload.searchSku );
            if(!payload.response[payload.searchSku]) reject('Product not found')
            var parsed = payload.response[payload.searchSku];
            console.log('sku-based response: ');
            for (const property in parsed) {
                let propName = `${property.replace('__c', '').replaceAll('_', '').charAt(0).toLowerCase()}${property.replace('__c', '').replaceAll('_', '').substr(1, property.length)}`
                //console.log('final propname:' +propName)
                let newValue = parsed[property];
                switch(propName){
                    case 'shortDescription': propName = 'productName'; break;
                    case 'sKU': propName = 'productSku'; break;
                    case 'retailPrice': propName = 'msrp'; break;
                    case 'imageURL': propName = 'productImageSrc'; 
                                     store.dispatch('ItemInfo/updateImageCollection', newValue);
                                     break;
                    case 'vendorCountry': propName = 'vendorLocation'; break;
                    case 'subCategory': propName = 'subcategory'; break;
                    case 'countryofOrigin': propName = 'origin'; break;
                    case 'buyer': propName = 'buyers'; break;
                    default: break;
                }
                store.commit('ItemInfo/updateState',{field: propName, value: parsed[property]} )
                dispatch('setPageValidation', {field: propName, value: parsed[property]})
            }
            console.log('end response: ');
        });
    },
    fetchItem({commit, dispatch}, payload){
        commit('updateState', {field: 'itemFetchError', value: ''}) 
        let searchSku = payload.sku;
        let storeLocation = payload.store;
        this._vm.$api.get('/api/itemCard/sku/' + searchSku)
            .then((response) => dispatch('parseFetched', {response, searchSku, storeLocation}))
            //.then(parsed => commit("setItem", parsed))
            .catch((error) => {
                store.commit('updateState', {field: 'itemFetchError', value: error})
                console.log('error retrieving product from sku: ' + error)
            });
    },
    setPageValidation({commit, dispatch, state}, payload){
        //console.log('page validation?');
        for(const group in state.validationGroups){
            let _this = Object.values(state.validationGroups[group]);
            if(_this.findIndex(x => x.name == payload.field) != -1){
                if (payload.value != '' && payload.value != null){
                    state.validationGroups[group][_this.findIndex(x => x.name == payload.field)].valid = true
                }
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
